

















import { Component, Prop, Vue } from "vue-property-decorator";
import { Page } from "@/router";

@Component
export default class Navbar extends Vue {
  $enums = {
    Page,
  };

  @Prop({ required: false }) helpTarget?: string;

  sourceLink: string = process.env.VUE_APP_SOURCE_URL;
}
